import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { DyEngagementTypes, FilterTypes } from '../../enums';
import { ChooseResponseCampaignModel } from '../../models/DynamicYield';

interface IDynamicYieldService {
  setDyId: (axiosConfig?: AxiosRequestConfig) => Promise<HttpResponse<null>>;
  chooseHomepage: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ChooseResponseCampaignModel[]>>;
  chooseCategory: (
    topLevelCategoryId: number,
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ChooseResponseCampaignModel[]>>;
  chooseProduct: (
    productId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ChooseResponseCampaignModel[]>>;
  chooseCart: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ChooseResponseCampaignModel[]>>;
  pageviewCategory: (
    topLevelCategoryId: number,
    categoryId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  engagement: (
    type: DyEngagementTypes,
    decisionId: string,
    slotId: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
  eventFilter: (
    filterTypeId: FilterTypes,
    filterNumericValue: number | null,
    filterStringValue: string | null,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const dynamicYieldService: IDynamicYieldService = {
  setDyId(axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/set-dy-id`,
      {},
      axiosConfig,
    );
  },
  chooseHomepage(axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/choose/homepage`,
      { previewToken: getDyApiPreview() },
      axiosConfig,
    );
  },
  chooseCategory(topLevelCategoryId, categoryId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/choose/category`,
      { topLevelCategoryId, categoryId, previewToken: getDyApiPreview() },
      axiosConfig,
    );
  },
  chooseProduct(productId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/choose/product`,
      { productId, previewToken: getDyApiPreview() },
      axiosConfig,
    );
  },
  chooseCart(axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/choose/cart`,
      { previewToken: getDyApiPreview() },
      axiosConfig,
    );
  },
  pageviewCategory(topLevelCategoryId, categoryId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/pageview/category`,
      { topLevelCategoryId, categoryId },
      axiosConfig,
    );
  },
  engagement(type, decisionId, slotId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/engagement`,
      { type, decisionId, slotId },
      axiosConfig,
    );
  },
  eventFilter(
    filterTypeId,
    filterNumericValue,
    filterStringValue,
    axiosConfig,
  ) {
    return ajax.post(
      `${config.benefitApiUrl}/dynamic-yield/event/filter`,
      { filterTypeId, filterNumericValue, filterStringValue },
      axiosConfig,
    );
  },
};

const getDyApiPreview = (): string | undefined => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get('dyApiPreview') ?? undefined;
};
